<!--查看争议-->
<template lang="pug">
    <el-dialog title="查看争议" width="50%" :append-to-body="true" :visible.sync='visible' :modal-append-to-body='false'>
        <el-form ref="form" :model="argureData" label-width="80px">
            <el-form-item label="提交人">
              <el-input v-model="argureData.uploadName" class="inputWidth" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="争议内容">
                <el-input type="textarea" :rows="5" v-model="argureData.content" :disabled="oprType === 'view'"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button v-if="oprType === 'edit'" type="primary" @click='modify'>提交修改</el-button>
            <el-button @click="visible = false">返回</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
  name: 'DownGradeRecorde',
  data () {
    return {
      row: '', // 争议
      oprType: '', // 操作类型
      visible: false,
      argureData: {
        name: 'whb',
        desc: 'hahahah'
      }
    }
  },
  methods: {
    init (row, operType) {
      this.argureData = row
      this.oprType = operType
      this.visible = true
      // this.getGameDetailData()
      // axios加载数据,或者从上一个界面带过来
    },
    modify () {
      this.$http({
        url: this.$http.adornUrl(`/mbMember/updateDebateById`),
        method: 'post',
        data: this.argureData
      }).then((data) => {
        if (data && data.code === 0) {
          this.$emit('refreshList')
          this.visible = false
        } else {
          this.$message.error(data.msg)
        }
      })
    }
    // // 获取数据
    // getGameDetailData () {
    //   this.$http({
    //     url: this.$http.adornUrl(
    //       `/mbMember/getDebateListByMemberId/${this.id}`
    //     ),
    //     method: 'get'
    //   }).then((data) => {
    //     if (data && data.code === 0) {
    //       this.argureData = data.data.rows
    //     } else {
    //       this.$message.error(data.msg)
    //     }
    //   })
    // }
  }
}
</script>
<style scoped>
</style>
